import Swal from 'sweetalert2'

// Uses sweetalert2 to display a confirmation modal
// When using turbo_method and turbo_confirm
// Instead of the browser's default dialog
// eslint-disable-next-line no-undef
Turbo.config.forms.confirm = (message, _element) => {
  return new Promise((resolve, reject) => {
    Swal.fire({
      title: 'Warning!',
      text: message || 'Are you sure?',
      icon: 'warning',
      showCancelButton: true,
      customClass: {
        title: 'sweet-farmplan--title',
        container: 'sweet-farmplan--container',
        cancelButton: 'sweet-farmplan--cancel-button',
        confirmButton: 'sweet-farmplan--confirm-button'
      }
    }).then((result) => {
      resolve(result.isConfirmed)
    }).catch(error => { reject(error) })
  })
}
